module.exports = __webpack_public_path__ + "img/logo.e359c62f.png";